$(function() {
  $('.inspirator').each(function() {
    const $inspiraceDiv = $(this);
    const $banner = $inspiraceDiv.find('.inspiratorBanner');

    const dataUrl = $inspiraceDiv.attr('data-url').trim();
//const dataUrl = "https://inspirator.shopcode.cz/json/collection-to-json?secure=tkenda9kh1t1u9wdiv9a";

    $.getJSON(dataUrl)
      .done(function(data) {
        if (data && data.length) {
          let finalHtml = '';
          let totalPoints = 0;
          data.forEach(item => {
            const imageUrl =
            item?.url && item.url.trim() !== ''
              ? item.url.replace('/upload/', '/www/upload/')
              : 'https://cdn.myshoptet.com/prj/dist/master/cms/img/common/missing_images/detail.png';

            let html = `
              <div class="inspirator-inner" data-id="${item.id}">
                <img src="${imageUrl}" alt="Inspirace ${item.id}">
                <ul>
            `;
           // console.log(item)
            item.points.forEach(point => {
              if (!point.product.name || point.product.name.trim() === '') return;

              totalPoints++;
const productImage =
            point.product?.image && point.product.image.trim() !== ''
              ? point.product.image.replace('/orig/', '/detail/')
              : 'https://cdn.myshoptet.com/prj/dist/master/cms/img/common/missing_images/detail.png';

              html += `
  <li style="top: ${point.top}%; left: ${point.left}%;">
    <span class="point"></span>
    <div class="inspiraceProduct">
      <span class="close"></span>
      <div class="image">
        <img src="${productImage}" alt="${point.product.name ?? ''}">
      </div>
      <div class="right">
        <div class="name">
          <span class="name">${
            (() => {
              const name = point.product?.name ?? '';
              const afterDash = name.includes('-') ? name.split('-')[1] : name;
              return afterDash.split('(')[0].trim();
            })()
          }</span>
        </div>
        <div class="price-line">
          <span class="price">${Number(point.product?.price ?? 0).ShoptetFormatAsCurrency()}</span>
          <a href="${point.product?.url ?? '#'}" class="btn btn-cart add-to-cart-button">Detail</a>
        </div>
      </div>
    </div>
  </li>
`;
            });

            html += `
                </ul>
              </div>
            `;
            finalHtml += html;
          });

          $banner.html(finalHtml);
          $banner.attr('data-count', totalPoints);
        } else {
          $inspiraceDiv.attr('data-alert', 'Data nejsou k dispozici.');
        }
      })
      .fail(function(jqXHR, textStatus, errorThrown) {
        console.error("Chyba při načítání JSONu:", textStatus, errorThrown);
      });
  });
});

$('html').on('click', '.inspirator-inner .point', function() {
  const $clickedLi = $(this).closest('li');
  $('body').addClass('inspiratorActive')
  $(".inspirator-inner .point").closest('li').not($clickedLi).removeClass("activeProduct");
  $clickedLi.toggleClass('activeProduct');
});

$('html').on('click', '.inspirator-inner .close', function() {
  $(this).closest('li').toggleClass('activeProduct');
   $('body').removeClass('inspiratorActive')
});
